import { createTenantsPhoneApi } from './phone/index';
import { createTenantApi } from './tenant/index';
export * from './phone';
export * from './tenant';
export var createTenantsApi = function (baseUrl, http) {
    var url = baseUrl + "/tenants";
    return {
        phone: createTenantsPhoneApi(url, http),
        tenant: createTenantApi(url, http)
    };
};
//# sourceMappingURL=index.js.map